// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bxmcfcnljcqgongyckwk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ4bWNmY25samNxZ29uZ3lja3drIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM4NjAyMTksImV4cCI6MjA2OTQzNjIxOX0.e3NBSmVmOrHcBbyEDEAtytH7rLQ6Kl0aebw-qNy9qww";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});